import { useState } from 'react';
import styled, { css } from 'styled-components';
import uploadImage from '../images/upload.gif';

import Api from '../utils/Api';

const uploadStyles = css`
  width: 100%;
  height: 100%;
  .loading {
    width: 100%;
    height: 100%;
  }
  input[type="file"] {
    display: none;
  }
  .custom-file-upload {
    cursor: pointer;
      & .visual {
        display: flex;
        flex-direction:column;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
    }
  }
`;

const ImageUploader = styled(({
  className,
  onError,
  onSuccess,
  onUploading,
  accept: _accept = ['image/gif', 'image/png', 'image/jpeg'],
  children
}) => {

  const [isUploading, setIsUploading] = useState(null);
  const accept = Array.isArray(_accept) ? _accept.join(',') : _accept;

  const onUpload = async file => {
    onUploading(true);
    setIsUploading(true);
    const [error, data] = await Api.uploadFile(file);
    setIsUploading(false);
    onUploading(false);
    if (error) return onError(error);
    return onSuccess(data);
  }

  return (
    <div className={className}>
      <label htmlFor="file-upload" className="custom-file-upload">
        <div className='visual'>
          {isUploading && <img className='loading' src={uploadImage} alt='uploading' />}
          {children}
        </div>
      </label>
      <input id="file-upload" type="file" accept={accept} onChange={e => onUpload(e.target.files[0])} />
    </div>
  )
})`${uploadStyles}`;

export default ImageUploader;